import { Col } from "react-bootstrap";

import classes from "../maintainers.module.scss";

const DealersActions = ({ handleGroup }) => {
	return (
		<>
			<Col md={1} className={classes.col_base_action}>
				<div className={classes.hr_vertical}></div>
				<div className={classes.text}>Seleccione una opción</div>
			</Col>
			<Col md={2} className={classes.col_action}>
				<div className={classes.action} onClick={() => handleGroup()}>
					Juntar Distribuidores
				</div>
			</Col>
		</>
	);
};

export default DealersActions;
